import React from 'react';
import { Skeleton } from '@genie-ui/react';
import './team-management-list-skeleton.scss';

function TeamManagementListSkeleton() {
  const renderListSkeleton = (_, index) => (
    <div className="team-management-list-skeleton__row" key={index}>
      <Skeleton variant="circular" className="team-management-list-skeleton__row__avatar" />
      <div className="team-management-list-skeleton__row__emailContainer">
        <Skeleton variant="rectangular" className="team-management-list-skeleton__row__name" />
        <Skeleton variant="rectangular" className="team-management-list-skeleton__row__email" />
      </div>
      <Skeleton variant="rectangular" className="team-management-list-skeleton__row__cta" />
    </div>
  );

  return (
    <div className="team-management-list-skeleton">
      {[...Array(3).keys()]?.map(renderListSkeleton)}
    </div>
  );
}

export default TeamManagementListSkeleton;
